import Axios from "axios";

const url_api = process.env.VUE_APP_API_URL;

export function create(data) {
  let token = window.vueApp.$store.state.token;
  let config = {
    headers: {
      'Access-Control-Allow-Origin': '*',
      Authorization: "bearer " + token
    }
  };
  return Axios.post(url_api + "/api/adversing", data, config);
}